import React from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@/modules/common/components/Button';
import SelectLevel from '@/modules/common/components/SelectLevel';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import DownloadMenu from '@/modules/common/components/DownloadMenu';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { base64toBlob } from '~/common';
import { actionSetDownloadingJournal } from '@/modules/application/actions/downloading';

const Top = (props) => {
    const fetch = (format) => {
        const url = `/api/journal/download/${format}/?${props.router.urlSearchParams.toString()}`;
        props.setFetching(true);
        props.fetch.get(url)
            .then(({ok, data}) => {
                if (ok) {
                    const blob = base64toBlob(data.blob);
                    saveAs(blob, `journal.${format}`);
                }
            })
            .finally(() => {
                props.setFetching(false);
            });
    };

    const handleClickDownload = (popupState, format) => () => {
        popupState.close();
        fetch(format);
    };

    return (
        <ContentBodyTop
            left={
                (props.journal.length > 0)
                    ? <DownloadMenu fetching={props.fetching} onClickDownload={handleClickDownload}/>
                    : null
            }
            right={
                <form id="form-filter" onSubmit={props.onSubmitFilter}>
                    <SelectLevel value={props.valuesFilter.levelno}
                                 onChange={(event) => props.setValuesFilter({
                                     ...props.valuesFilter,
                                     levelno: event.target.value
                                 })}
                    />
                    <ButtonGroup>
                        {(props.isFiltered)
                            ? <Button onClick={props.onClickResetFilter}>Очистить фильтр</Button>
                            : null
                        }
                        <Button type="submit">Применить фильтр</Button>
                    </ButtonGroup>
                </form>
            }/>
    );
};

Top.propTypes = {
    journal: PropTypes.array.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    valuesFilter: PropTypes.object.isRequired,
    setValuesFilter: PropTypes.func.isRequired,
    onClickResetFilter: PropTypes.func.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
};

let Component = Top;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    (state) => ({
        fetching: state.downloading.journal,
    }),
    (dispatch) => ({
        setFetching: bindActionCreators(actionSetDownloadingJournal, dispatch),
    })
)(Component);
